import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  mainText: string;
  subText?: string;
  className?: string;
  variant?: 'primary' | 'white';
  href?: string;
}
export function CTAButton({
  mainText,
  subText,
  className = '',
  variant = 'primary',
  href = 'https://pay.hotmart.com/K105564779B?checkoutMode=10'
}: CTAButtonProps) {
  const isWhite = variant === 'white';
  const handleClick = () => {
    if (href !== '#final-cta' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Calma en Casa',
        content_type: 'product',
        value: 7.0,
        currency: 'USD'
      });
    }
  };
  return <div className="flex flex-col items-center w-full max-w-xl mx-auto" data-id="element-18">
      <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`group relative flex flex-col items-center justify-center w-full rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-all duration-300 ${isWhite ? 'bg-white hover:bg-slate-50 text-brand-orange' : 'bg-brand-orange hover:bg-brand-orangeHover text-white'} ${className}`} data-id="element-19">
        <span className="font-sans font-bold text-lg sm:text-xl md:text-2xl text-center tracking-wide" data-id="element-20">
          {mainText}
        </span>

        <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none" data-id="element-21">
          <div className="absolute top-0 left-[-100%] w-1/2 h-full bg-white/20 skew-x-[-20deg] group-hover:animate-[shine_1.5s_ease-in-out]" data-id="element-22" />
        </div>
      </motion.a>

      {subText && <span className="font-sans text-xs sm:text-sm mt-3 text-slate-500 font-medium text-center" data-id="element-23">
          {subText}
        </span>}
    </div>;
}